import React from "react";
export default function FormatDate(props){
    let days =[
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    ];
    let day = days[props.date.getDay()];
    let hour = props.date.getHours();
    if (hour <10 ) {
        hour = `0${hour}`;
    }
    let minutes = props.date.getMinutes();
    if (minutes <10 ){
        minutes =`0${minutes}`;
    }
    return <div className="FormatDate" style={{display : "inline"}}>
        {day} {hour}:{minutes}
    </div>
}